import React from 'react';

import Lottie from 'lottie-react-web';

import animation from './json/index.plk.json';

const Animation = () => <Lottie options={{ animationData: animation }} />;

export default Animation;
